import {makeJobTaskDescriptor} from "@cm/job-nodes/job-nodes"

export type ConfiguraPublishInput = {
    /**
     * The binding to publish, and the only thing the job is told. It must already exist — the trigger
     * mutation creates it; the job only updates. Passed rather than looked up: the binding is a root
     * entity with no relation from Material, so finding it would mean filtering the list — and `list`
     * is granted platform-wide, so the scoping would fall to a broader `read` than publishing needs.
     *
     * The material is deliberately absent: it is reachable through the binding, and a second copy in
     * the graph could disagree with it.
     */
    bindingId: string
}

// The graph deliberately carries neither the credential nor the endpoint. The task reads its
// credential from the organization's profile over GraphQL (as ciphertext, decrypted at its own
// boundary) and its endpoint from CM_CONFIGURA_MATERIAL_DATABASE_ENDPOINT — so a persisted, readable
// job graph exposes nothing, and a hand-crafted one cannot point a job at another Material Database.

export const configuraPublishTask = makeJobTaskDescriptor<ConfiguraPublishInput, {}>("MaterialOutputsPublishing.configura", 1)
